function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { useEffect, Fragment, useCallback } from 'react';
import Sezzle from './Assests/sezzle.jpg';
import PaymentCards from './Assests/stokesCards.svg';
import Facebook from './Assests/facebook.svg';
import Instagram from './Assests/instagram.svg';
import Youtube from './Assests/youtube.svg';
import Pinterest from './Assests/pinterest.svg';
import { shape, string } from 'prop-types';
import { useFooter } from '@magento/peregrine/lib/talons/Footer/useFooter';
import parse_html from '@magento/pagebuilder/lib/helper.js';
import { ArrowRight } from 'react-feather';
import { mergeClasses } from '../../classify';
import defaultClasses from './footer.css';
import { useLocation } from 'react-router-dom';
import useMediaQuery from 'react-use-media-query-hook';
import { MEDIA_MAX_MOBILE } from '../../helpers/mediaQuery';
import { useToasts, useWindowSize } from '@magento/peregrine';
import { useMutation } from '@apollo/client';
import SUBSCRIBE_TO_NEWSLETTER from '../../queries/subscribeToNewsletter.graphql';
import { ErrorIcon, SuccessIcon } from '../App/app';
import { useIntl } from 'react-intl';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import { saveEncryptedEmailPersistence, sendGTMEvent } from "@magento/venia-ui/lib/util/initGTM";
import { BrowserPersistence } from "@magento/peregrine/lib/util";
import BBLink from "../BBLink";
var storage = new BrowserPersistence();
var Footer = props => {
  var location = useLocation();
  var classes = mergeClasses(defaultClasses, props.classes);
  var talonProps = useFooter();
  var {
    menuFooter,
    blockSocialMedia
  } = talonProps;
  var isTablet = useWindowSize().innerWidth < 770;
  var [, {
    setOpenStoreModal
  }] = useAppContext();
  var isMaxMobile = useMediaQuery(MEDIA_MAX_MOBILE);
  var [, {
    addToast
  }] = useToasts();
  var {
    formatMessage
  } = useIntl();
  var [subscribeToNewsletter] = useMutation(SUBSCRIBE_TO_NEWSLETTER, {
    fetchPolicy: 'no-cache'
  });
  var NOIBU_ENABLED = process.env.NOIBU_ENABLED === 'true' && process.env.NOIBU_DOMAIN_ID;
  var handleOpenStoreModal = useCallback(() => setOpenStoreModal(true), []);
  var handleOpenChat = useCallback(() => {
    var chatElement = document.getElementById('HeydayStartIconContainer');
    if (chatElement) {
      chatElement.click();
    }
    var currentPath = storage.getItem("currentPath");
    if (currentPath.includes('cart')) {
      sendGTMEvent({
        eventCategory: 'checkout step 1 - cart',
        eventAction: 'Chat icon',
        eventLabel: 'Start chat',
        event: 'genericGAEvent'
      });
    }
  }, []);
  var handleSubscribe = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (event) {
      try {
        event.preventDefault();
        var email = event.target.email.value;
        yield subscribeToNewsletter({
          variables: {
            email
          }
        });
        saveEncryptedEmailPersistence(email);
        sendGTMEvent({
          event: 'newsletter_signup'
        });
        addToast({
          type: 'info',
          icon: SuccessIcon,
          message: formatMessage({
            id: 'app.subscribeNewsletterSuccess',
            defaultMessage: 'Email was sent successfully!'
          }),
          timeout: 3000
        });
      } catch (err) {
        addToast({
          type: 'error',
          icon: ErrorIcon,
          message: formatMessage({
            id: 'app.subscribeNewsletterError',
            defaultMessage: err.message
          }),
          timeout: 3000
        });
      }
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [addToast, formatMessage, subscribeToNewsletter]);
  useEffect(() => {
    setTimeout(() => {
      var chatIcon = document.getElementById('HeydayStartIconContainer');
      if (chatIcon) {
        chatIcon.addEventListener('click', openChatModal);
      }
    }, 5000);
  }, []);
  var openChatModal = () => {
    sendGTMEvent({
      eventCategory: 'checkout step 1 - cart',
      eventAction: 'Chat icon',
      eventLabel: 'Start chat',
      event: 'genericGAEvent'
    });
  };
  var footerIcons = menuFooter && menuFooter[3] && menuFooter[3].right && menuFooter[3].right.map((footer, index) => /*#__PURE__*/React.createElement("div", {
    key: "parentFooter-".concat(index),
    className: classes.footerContainerInfo
  }, footer.right.map((item, index) => {
    if (item.classes === 'image') {
      return /*#__PURE__*/React.createElement("img", {
        key: "".concat(item.name, "-").concat(index),
        src: item.image_path,
        alt: ""
      });
    }
    if (item.classes === 'title') {
      return /*#__PURE__*/React.createElement("h4", {
        key: "".concat(item.name, "-").concat(index)
      }, item.name);
    }
    if (item.classes === 'info') {
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(item.name, "-").concat(index),
        className: classes.info
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: item.name
        }
      }));
    }
    if (item.classes === 'button') {
      return /*#__PURE__*/React.createElement("a", {
        key: "".concat(item.name, "-").concat(index),
        className: classes.contact,
        href: item.url_path,
        onClick: item.image_alt_text === 'setOpenStoreModal' ? handleOpenStoreModal : item.image_alt_text === 'openChat' ? handleOpenChat : null
      }, item.name);
    }
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(item.name, "-").concat(index)
    }, /*#__PURE__*/React.createElement(BBLink, {
      className: classes.contact,
      to: '/' + item.url_path
    }, item.name));
  })));
  var signUp = menuFooter && menuFooter[4] && menuFooter[4].right && menuFooter[4].right.map((footer, index) => {
    var titleBold = footer.right.map((i, index) => {
      if (i.classes === 'bold') {
        return /*#__PURE__*/React.createElement("span", {
          key: "".concat(i.name, "-").concat(index)
        }, i.name);
      }
    });
    if (footer.classes === 'title') {
      return /*#__PURE__*/React.createElement("h2", {
        key: "".concat(footer.name, "-").concat(index)
      }, footer.name, " ", titleBold);
    }
    if (footer.classes === 'info') {
      return /*#__PURE__*/React.createElement("p", {
        key: "".concat(footer.name, "-").concat(index)
      }, footer.name);
    }
    if (footer.classes === 'button') {
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubscribe,
        className: classes.newsLetterBtnContainer,
        key: "".concat(footer.name, "-").concat(index)
      }, /*#__PURE__*/React.createElement("input", {
        className: classes.newsLetterInput,
        type: "text",
        name: "email",
        placeholder: formatMessage({
          id: "footer.enterEmailAddressPlaceholder",
          defaultMessage: "Enter email address"
        })
      }), /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: classes.newsLetterBtn
      }, isTablet ? /*#__PURE__*/React.createElement(ArrowRight, {
        size: 18
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, footer.name)));
    }
  });
  var bottomFooter = menuFooter && menuFooter[5] && menuFooter[5].right && menuFooter[5].right.map((footer, index) => {
    if (isTablet ? footer.classes === 'mobile' : footer.classes === 'desktop') {
      return /*#__PURE__*/React.createElement("p", {
        key: "".concat(footer.name, "-").concat(index)
      }, footer.name);
    }
  });
  var newsletterTitle = menuFooter && menuFooter[2] && menuFooter[2].right && menuFooter[2].right.map((footer, index) => {
    var titleBold = footer.right.map((i, index) => {
      if (i.classes === 'bold') {
        return /*#__PURE__*/React.createElement("span", {
          key: "".concat(footer.name, "-").concat(index)
        }, i.name);
      }
    });
    if (footer.classes === 'title') {
      return /*#__PURE__*/React.createElement("h2", {
        className: classes.footerTitle,
        key: "".concat(footer.name, "-").concat(index)
      }, footer.name, " ", titleBold);
    }
  });
  var newsletterFooter = menuFooter => {
    menuFooter.right.sort((a, b) => a.position - b.position);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, menuFooter.name)), menuFooter.right.map((i, index) => {
      if (!i.is_active) {
        return null;
      }
      if (i.classes === 'buttonStoreLocator') {
        return /*#__PURE__*/React.createElement("button", {
          key: 'buttonStoreLocator' + index,
          onClick: handleOpenStoreModal
        }, parse_html(i.name));
      }
      if (i.classes === 'noibu') {
        return /*#__PURE__*/React.createElement(React.Fragment, null, NOIBU_ENABLED && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          id: "request-help-code"
        }, parse_html(i.name)), /*#__PURE__*/React.createElement("div", {
          id: "help-code-result"
        })));
      }
      return /*#__PURE__*/React.createElement(BBLink, {
        key: "".concat(i.name, "-").concat(index),
        forceNewTab: i.target === "_blank",
        to: i.url_path
      }, parse_html(i.name));
    }));
  };
  var Payment = Data.cards.map((img, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: "card-".concat(index)
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.cardsImages,
    src: img.img,
    alt: ""
  })));
  var SocialMedia = blockSocialMedia ? blockSocialMedia : Data.social.map((img, index) => /*#__PURE__*/React.createElement("div", {
    key: "card-".concat(index)
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.socialImages,
    src: img.img,
    alt: ""
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.rootContainer
  }, location.pathname !== '/success' && location.pathname !== '/checkout' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("footer", null, newsletterTitle, /*#__PURE__*/React.createElement("div", {
    className: classes.footerContainer
  }, footerIcons)), /*#__PURE__*/React.createElement("div", {
    className: classes.newsletter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.newsletterHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.newsletterInfo
  }, /*#__PURE__*/React.createElement("ul", null, menuFooter && newsletterFooter(menuFooter[0])), /*#__PURE__*/React.createElement("ul", null, menuFooter && newsletterFooter(menuFooter[1]))), /*#__PURE__*/React.createElement("div", {
    className: classes.newsletterOuterContainer,
    id: "newsletterContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.newsletterContainer
  }, signUp))))), (location.pathname === '/success' || location.pathname === '/checkout') && /*#__PURE__*/React.createElement("div", {
    className: classes.footerCustomerContent
  }, menuFooter && menuFooter[1].right.map((i, index) => /*#__PURE__*/React.createElement(BBLink, {
    key: "".concat(i.name, "-").concat(index),
    to: '/' + i.url_path
  }, parse_html(i.name)))), /*#__PURE__*/React.createElement("div", {
    className: classes.socialContainer
  }, isMaxMobile && /*#__PURE__*/React.createElement("div", {
    className: classes.socialMedia
  }, SocialMedia), /*#__PURE__*/React.createElement("div", {
    className: classes.socialPayment
  }, Payment), !isMaxMobile && /*#__PURE__*/React.createElement("div", {
    className: classes.socialMedia
  }, SocialMedia)), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, bottomFooter)));
};
export default Footer;
var Data = {
  cards: [{
    key: 'PaymentCards',
    img: PaymentCards
  }, {
    key: 'Sezzle',
    img: Sezzle
  }],
  social: [{
    key: 'Facebook',
    img: Facebook
  }, {
    key: 'Instagram',
    img: Instagram
  }, {
    key: 'Youtube',
    img: Youtube
  }, {
    key: 'Pinterest',
    img: Pinterest
  }]
};
Footer.propTypes = {
  classes: shape({
    root: string,
    footerTitle: string
  })
};